import { ReactNode } from 'react';

import { appendTestableElementAttributes } from '@dreryk/react-components';

import {
   StyledPrescriptionVisitHeader,
   StyledPrescriptionVisitHeaderDetails,
   StyledPrescriptionVisitHeaderPatientContent,
} from './PrescriptionVisitHeader.styled';

type PrescriptionVisitHeaderProps = {
   readonly title?: ReactNode;
   readonly details?: ReactNode;
   readonly actions?: ReactNode;
};

export const PrescriptionVisitHeader = (props: PrescriptionVisitHeaderProps): JSX.Element => {
   return (
      <StyledPrescriptionVisitHeader {...appendTestableElementAttributes('visitHeader')}>
         <StyledPrescriptionVisitHeaderPatientContent>
            {props.title}
            {props.actions}
         </StyledPrescriptionVisitHeaderPatientContent>
         <StyledPrescriptionVisitHeaderDetails>{props.details}</StyledPrescriptionVisitHeaderDetails>
      </StyledPrescriptionVisitHeader>
   );
};
